import { usePostOfficeEnvironment, useStableObject } from '@atlassian/post-office-context';
import {
	type PlacementOnEvent,
	Placement as SharedPlacementWrapper,
} from '@atlassian/post-office-placement-shared';
import { RemoteComponent } from '@atlassian/remote-module-loader/remote-component';
import { type FunctionComponent, type PropsWithChildren, type ReactElement } from 'react';

import { ANALYTICS_CHANNEL } from './constants';
import PluginRegistry from './pluginRegistry';

const STABLE_OBJECT: RemotePlacementProps = {};

type RemotePlacementProps = Record<string, unknown>;

interface BaseProps {
	placementId: string;
	placementProps?: RemotePlacementProps;
	ErrorFallback?: ReactElement | null;
	Fallback?: ReactElement | null;
	onEvent?: PlacementOnEvent;
}

export type PlacementProps = PropsWithChildren<BaseProps>;
const Placement: FunctionComponent<PlacementProps> = ({
	placementId,
	placementProps,
	children,
	ErrorFallback,
	Fallback,
	onEvent,
}) => {
	const environmentContext = usePostOfficeEnvironment();

	const pluginRegistry = PluginRegistry.getRegistry();
	const plugin = pluginRegistry.getPluginForPlacement(placementId, environmentContext);

	const stableRemotePlacementProps = useStableObject<RemotePlacementProps>(
		placementProps ?? STABLE_OBJECT,
	);

	return (
		<SharedPlacementWrapper placementId={placementId} consumptionType="remote" onEvent={onEvent}>
			{({ initialData, onEvent: sharedOnEvent, context }) => (
				<RemoteComponent
					analyticsChannel={ANALYTICS_CHANNEL}
					remotePlugin={plugin}
					onEvent={sharedOnEvent}
					ErrorFallback={ErrorFallback}
					Fallback={Fallback}
					initialData={initialData}
					context={context}
					{...stableRemotePlacementProps}
				>
					{children}
				</RemoteComponent>
			)}
		</SharedPlacementWrapper>
	);
};

export default Placement;
